/* Brand polish — small interaction enhancements.
 * - Scroll-reveal on PDP editorial sections (paired with brand-polish.css).
 * - Honors prefers-reduced-motion (just applies the visible state immediately).
 * - Uses IntersectionObserver; falls back to instant-reveal on older browsers.
 */
(function () {
  if (window.__brandPolishBooted) return;
  window.__brandPolishBooted = true;

  function isReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function selectRevealTargets() {
    // Only PDP editorial sections — keeps the reveal narrow.
    if (!document.body || !document.body.classList.contains('product-template')) return [];
    return document.querySelectorAll([
      '[id*="why_this"]',
      '[id*="ingredients_deep"]',
      '[id*="how_to_use"]',
      '[id*="faq"]:not([id*="faq-content"])',
      '[id*="final_cta"]'
    ].join(','));
  }

  function init() {
    var targets = selectRevealTargets();
    if (targets.length === 0) return;

    // Reduced motion → reveal everything immediately, skip the observer.
    if (isReducedMotion() || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.05
    });

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
